/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.RatingsControlPanel {
    angular.module('meevo.plugins.ratingsControlPanel', []);
}